import React from 'react'
import images from '../../config/images'
import { Header } from './styles'
import Profile from '../../components/Profile/NavBarProfile'

const AppBar = ({newSeminarUpgradeModal, location}) => (
  <Header
    className="pr3 pl3"
    style={{
      zIndex: 100,
      backgroundImage: 'linear-gradient(135deg, #3186f9 0%, #3186f9 30%, #3186f9 90%, #3186f9 100%)'
    }}
    title={
      <div className='h-100 pl3 flex justify-around flex-column'>
        <img src={images.webinar_logo} alt="logo" style={{width: 120, cursor: 'pointer'}}
             onClick={() => {window.open('https://webinar.freshvoice.net/')}}/>
      </div>
    }
    iconElementRight={
      <Profile
        location={location}
        newSeminarUpgradeModal={newSeminarUpgradeModal}
      />
    }
    showMenuIconButton={false}
  />
)

export default AppBar



// WEBPACK FOOTER //
// ./src/layouts/LoggedIn/AppBar.js